import { useEffect, useMemo, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import { HeaderBottom, HeaderTop } from "../components/Header.jsx";
import { FooterBottom, FooterTop } from "../components/Footer.jsx";
import { layout_cover_image } from "../utils/config/site_urls.js";
import { insertTextbeforeUrlExtention } from "../utils/general/text-formatting.js";
import { res_layout_background_image } from "../utils/config/image-resolutions.js";
// import BlogSidebar from "../components/BlogSidebar.jsx";
import VacancySidebar from "../components/VacancySidebar.jsx";

export default function Layout() {
  const [isHeaderBottomHidden, setIsHeaderBottomHidden] = useState(false);
  const headerBottomRef = useRef(null);

  const bgUrl = useMemo(() => insertTextbeforeUrlExtention(layout_cover_image, res_layout_background_image), []);

  useEffect(() => {
    if (!bgUrl) return;
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = bgUrl;
    document.head.appendChild(link);
    return () => {
      try {
        document.head.removeChild(link);
      } catch {}
    };
  }, [bgUrl]);

  useEffect(() => {
    const currentHeaderBottomRef = headerBottomRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsHeaderBottomHidden(!entry.isIntersecting);
      },
      { threshold: 0 }
    );

    if (currentHeaderBottomRef) {
      observer.observe(currentHeaderBottomRef);
    }

    return () => {
      if (currentHeaderBottomRef) {
        observer.unobserve(currentHeaderBottomRef);
      }
    };
  }, []);

  return (
    <div
      className="relative flex flex-col min-h-screen"
      style={{
        backgroundImage: `url(${bgUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="fixed top-0 w-full z-50">
        <HeaderTop isHeaderBottomHidden={isHeaderBottomHidden} />
      </div>

      {/* Scrollable Content */}
      <div className="mt-16 flex-1 flex flex-col">
        <div ref={headerBottomRef}>
          <HeaderBottom isHeaderBottomHidden={isHeaderBottomHidden} />
        </div>
        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </div>

      {/* Footer always at the bottom */}
      <footer className="w-full">
        <FooterTop />
        <FooterBottom />
      </footer>

      {/* <BlogSidebar /> */}
      <VacancySidebar />
    </div>
  );
}
